<template>
  <div class="d-flex-column justify-start align-start gap-18">
    <h5 class="title-h5 font-family-1 t-white f-w-600">
      {{ $t("new.select_level") }}
    </h5>
    <div class="level_picker_content d-flex-column justify-start align-start">
      <div
        class="d-flex-row space-between md-row-to-col"
        style="margin-bottom: 20px"
      >
        <LevelAdjusters
          :title="$t('new.current_level')"
          :description="$t('new.select_current_level')"
          v-model="levelRange.min"
          :min="1"
          :max="levelRange.max - 1"
          :defaul-value="1"
        />
        <LevelAdjusters
          :title="$t('new.desired_level')"
          :description="$t('new.select_desired_level')"
          v-model="levelRange.max"
          :min="levelRange.min + 1"
          :max="max"
          :defaul-value="max"
        />
      </div>
      <DualRangePicker
        :steps="steps"
        :min="1"
        :max="max"
        v-model="levelRange"
        :step="1"
      />
    </div>
  </div>
</template>

<script setup>
import LevelAdjusters from "../../wow/pickers/LevelAdjusters.vue";
import DualRangePicker from "../../commonpickers/DualRangePicker.vue";
const checkoutStore = useCheckoutStore();

const steps = ref([
  {
    title: "1",
  },

  {
    title: "48",
  },
]);

const levelRange = ref({
  min: 1,
  max: 48,
});

const max = ref(48);

const timeout = ref(null);

watch(
  levelRange,
  (newVal) => {
    checkoutStore.setDetails({
      currentLevel: levelRange.value.min,
      desiredLevel: levelRange.value.max,
    });
  },
  {
    deep: true,
  }
);

watch(
  () => checkoutStore.getCamoWeapon,
  (newVal) => {
    const hasLauncher = newVal.some((wp) => {
      return wp.class === "launcher";
    });
    if (hasLauncher) {
      steps.value = [
        {
          title: "1",
        },

        {
          title: "30",
        },
      ];

      levelRange.value = {
        min: 1,
        max: 30,
      };
      max.value = 30;
      return;
    } else {
      steps.value = [
        {
          title: "1",
        },

        {
          title: "48",
        },
      ];
      max.value = 48;
      levelRange.value = {
        min: 1,
        max: 48,
      };
    }
  }
);
</script>
